import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { IClientJob } from '../../interfaces/client-job.interface';
import { orderBy } from 'lodash';
import { ImagesService } from 'src/modules/shared/services/images.service';
import { NavController } from '@ionic/angular';
import { IUser } from 'src/modules/authentication/interfaces/user.interface';
import { ViewCertificateModalComponent } from 'src/modules/shared/components/view-certificate-modal/view-certificate-modal.component';
import { UserService } from 'src/modules/shared/services/user.service';
import { ModalController } from '@ionic/angular';


@Component({
  selector: 'app-open-request-direct-hire',
  templateUrl: './open-request-direct-hire.component.html',
  styleUrls: ['./open-request-direct-hire.component.scss'],
})
export class OpenRequestDirectHireComponent implements OnInit, OnChanges {
  staffersAndShifts = [];
  hiredStaffers = [];
  pendingConfirmationStaffers = []
  profileImage: string;
  @Input() jobItem: IClientJob;
  @Input() userData: IUser;
  @Input() previousShiftView? : boolean = false;
  // Opt-in reskin hook: the client requests page passes 'staffy-requests'; every other caller renders as before
  @Input() cssClass: string = '';

  constructor(private imagesService: ImagesService,
  private modalController: ModalController,
  private userService: UserService) { }

  ngOnInit() { 
  }
  ngOnChanges() {

    // Step 1: Ensure `staffersAndShifts` is not null or undefined
    if (!this.jobItem || !this.jobItem?.staffersAndShifts?.length) {
      this.staffersAndShifts = [];
      return;
    }
    

    this.staffersAndShifts = this.jobItem.staffersAndShifts.map(item=>{
      return {
        ...item,
        staffer: typeof item.staffer !== "object"?  this.jobItem.hiredStaffers.find(staffer => staffer._id.toString() == item.staffer) : item.staffer
      }
    });
    this.staffersAndShifts = this.staffersAndShifts.filter((attendant) => {
      return attendant.state !== 'rejected';
    }).map(attendant => ({
      ...attendant,
      profileImage: this.imagesService.getProfilePic(attendant.staffer.profileUrl),
      isProvinceNY: attendant.staffer.address.province === 'New_York' ? true : false,
      distanceInMiles: attendant.distanceFromShift.toFixed(2) / 1.609,
      distanceInKm: attendant.distanceFromShift.toFixed(2)

    }));

    this.staffersAndShifts = orderBy(this.staffersAndShifts, ['shiftStartTime'], ['asc']);


    this.hiredStaffers = this.staffersAndShifts.filter(attendant=>attendant.isConfirmedShift)

    if (this.jobItem.staffers && this.previousShiftView) {
      this.hiredStaffers = this.hiredStaffers.filter(stafferObj => {
        return this.jobItem.staffers.findIndex(staffer => staffer.staffer.toString() == stafferObj.staffer._id.toString()) > -1
      })
    }
    
    this.pendingConfirmationStaffers = this.staffersAndShifts.filter(attendant=>!attendant.isConfirmedShift)
  }


	async viewStafferCertificates(id: string, isCOVID: boolean) {
    const approvedCertificates = await this.userService.getApprovedCertificatesOfStaffer(id, isCOVID);

    const myModal = await this.modalController.create({
      component: ViewCertificateModalComponent,
      cssClass: 'viewCertificateModal',
      componentProps: {
        approvedCertificates,
        isCOVID: isCOVID
      }
    });
    await myModal.present();
  }

}
